module.exports = __webpack_public_path__ + "media/images/icon_company_badge3-70ce5b6b8f8a1dc861488cbc08c66c75.svg";